import { connectFela } from '../../dependencies';
import SignUpForm from './SignUpForm';
import * as styles from './SignUpForm.styles';

export default connectFela(styles)(SignUpForm);
